// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"193":"38744b58","427":"b869404f","477":"679f63ce","531":"b37cf1d2","787":"28cb0dcd"}[chunkId] + ".chunk.js";
};